<template>
 <svg :style="style" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<g id="&#230;&#150;&#185;&#229;&#188;&#143;=&#231;&#148;&#181;&#232;&#175;&#157;&#233;&#154;&#143;&#232;&#174;&#191;, &#230;&#152;&#175;&#229;&#144;&#166;&#228;&#184;&#186;&#230;&#181;&#133;&#232;&#137;&#178;=on">
<g id="Frame" clip-path="url(#clip0_4386_91497)">
<path id="Vector" d="M14.9357 11.7112C14.2835 10.9232 13.4709 10.5488 12.9257 10.5319C12.5634 10.5199 12.0991 10.8616 12.0991 10.8616L11.0462 11.5901C11.0462 11.5901 10.7053 11.9408 10.3468 11.9266C9.91391 11.9112 9.4471 11.5293 9.4471 11.5293C9.4471 11.5293 7.97943 10.3906 6.92389 9.09356C5.89466 7.82907 5.27778 6.40796 5.27778 6.40796C5.27778 6.40796 5.14949 6.0862 5.23989 5.82765C5.34617 5.52201 5.67415 5.27199 5.67415 5.27199L6.78223 4.50566C6.78223 4.50566 7.21637 4.23994 7.29495 3.8911C7.29727 3.87819 7.41851 3.30407 7.20121 2.66982C7.13701 2.48554 6.96341 1.9248 6.57958 1.47263C6.20988 1.03661 5.6339 0.708624 5.36375 0.589118C4.93402 0.398662 4.39048 0.471614 4.28779 0.483255C3.87903 0.52956 3.41765 1.03115 3.41765 1.03115C3.41765 1.03115 2.01752 2.41377 1.65706 4.06907C1.2609 5.88031 2.32871 8.40391 4.16003 10.6979C5.55559 12.4493 7.45264 13.9441 7.45264 13.9441C7.45264 13.9441 8.05331 14.4454 8.69837 14.8111C8.96898 14.9648 10.4631 15.8767 12.6235 15.5255C13.9224 15.314 15.2774 14.4901 15.2774 14.4901C15.2774 14.4901 15.7802 14.228 15.8071 13.913C15.8461 13.4613 15.4717 12.3614 14.9357 11.7112ZM4.18104 1.58131C4.33054 1.40687 4.78752 1.20839 4.78752 1.20839C4.78752 1.20839 5.42238 1.46564 5.85268 1.98196C6.29736 2.51622 6.53748 3.30955 6.53748 3.30955C6.53748 3.30955 6.42738 3.54006 6.23743 3.63516C6.03067 3.73966 5.74209 3.709 5.74209 3.709L4.12517 1.9812C4.12517 1.9812 4.00221 1.792 4.18104 1.58131ZM14.7869 13.4523C14.7206 13.6194 14.3979 13.6959 14.3979 13.6959C14.3979 13.6959 13.572 13.5861 13.0667 13.1858C12.4949 12.7367 12.2347 11.9892 12.2347 11.9892C12.2347 11.9892 12.225 11.6699 12.4301 11.4612C12.7536 11.1307 13.3017 11.2768 13.9775 11.8925C14.4442 12.3194 14.6642 13.0199 14.6642 13.0199C14.6642 13.0199 14.8549 13.2831 14.7869 13.4523Z" fill="#D2D5D9"/>
</g>
</g>
<defs>
<clipPath id="clip0_4386_91497">
<rect width="16" height="16" fill="white"/>
</clipPath>
</defs>
</svg>





</template>

<script>
export default {
  name: 'icon-phone-visit-black',
  props: {
    fontSize: {
      type: String,
      default: '18px'
    },
    color: {
      type: String,
      default: 'white'
    }
  },
  data() {
    return {
      style: {
        width: '1em',
        height: '1em',
        'vertical-align': 'middle',
        fill: 'currentColor',
        overflow: 'hidden',
        cursor: 'pointer',
        'font-size': this.fontSize
      }
    }
  }
}
</script>